import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../../../services/common/auth.service';

@Component({
  selector: 'app-vendor-new',
  templateUrl: './vendor-new.component.html',
  styleUrls: ['./vendor-new.component.css'],
})
export class VendorNewComponent implements OnInit {
  constructor(private router: Router, private authService: AuthService) {
    this.authService.fetchUserGroups().then((response_json) => {
      let groups = response_json.groups;
      if (groups.indexOf('personnel') > -1 || groups.indexOf('admin') > -1 || groups.indexOf('management') > -1 || groups.indexOf('owner') > -1) return;
      else this.router.navigate(['/']);
    });
  }

  ngOnInit() {}
}
